import Art from './Art'

// A block of explanation: a heading and some paragraphs, held to a readable
// measure. The money, trust and compliance pages are mostly this, and they are
// the pages people actually read rather than scan.
//
// `art` takes one of the apps' own 72×72 drawings (shared/announcementIcons.js,
// which has 24 of them: payday, wallet, safety, compliance, rate, support,
// location…). It isn’t decoration for its own sake: a page of six prose blocks
// is a wall, and a small picture per block gives the eye somewhere to land and
// makes the section scannable before it is read. On a wide screen it sits in the
// left margin so the text keeps its measure; on a phone it stacks above.
//
// ⛔ Art only, never meaning. The heading carries that, which is why the picture
// is aria-hidden by default inside <Art>.

export default function Prose({ id, title, art, children }) {
  return (
    <div id={id} className="scroll-mt-24 border-t border-hairline pt-10 md:flex md:gap-8">
      {art && <Art xml={art} className="h-[56px] w-[56px] shrink-0 md:h-[64px] md:w-[64px]" />}
      <div className={art ? 'mt-4 md:mt-0' : ''}>
        <h2 className="text-[26px] font-bold tracking-[-0.01em] md:text-[32px]">{title}</h2>
        <div className="mt-4 space-y-4 text-[18px] leading-relaxed text-ink-muted">{children}</div>
      </div>
    </div>
  )
}
